module.exports = __webpack_public_path__ + "static/media/vitlogo.2bac7aeb.png";